const itemFeedReducer = (
    state = {itemFeed: [], loading: false, error: false, hasMore: false, totalItems: 0}, 
    action
) => {
    switch(action.type) {
        case "ITEM_FEED_START":
            return {...state, loading: true, error: false}
        case "ITEM_FEED_SUCCESS":
            // console.log(action.data);
            return {...state, itemFeed: action.page === 0 ? action.data : [...state.itemFeed, ...action.data], hasMore: action.hasMore, totalItems: action.totalItems, loading: false, error: false}
        case "ITEM_FEED_FAIL":
            return {...state, loading: false, error: true}
        
        case "LOG_OUT":
            return {itemFeed: null, loading: false, error: false}

        default: 
            return state
    }
}

export default itemFeedReducer